import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav_home: "Accueil",
    nav_about: "À propos",
    nav_services: "Services",
    nav_projects: "Projets",
    nav_daily_life: "Notre Quotidien",
    nav_training: "Formations",
    nav_careers: "Carrières",
    nav_shop: "Boutique",
    nav_partners: "Partenaires",
    nav_contact: "Contact",
    nav_admin: "Administration",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",
    nav_get_quote: "Demander un devis",
    
    // Hero
    hero_title: "Bâtir l'avenir,",
    hero_title_2: "Connecter le monde",
    hero_subtitle: "GTIC SARL, votre partenaire de confiance pour la construction, la communication et les services d'impression.",
    hero_cta: "Découvrir nos services",
    hero_contact: "Nous contacter",
    
    // About
    about_title: "À propos de GTIC SARL",
    about_history: "Notre Histoire",
    about_vision: "Notre Vision",
    about_mission: "Notre Mission",
    about_values: "Nos Valeurs",
    about_history_text: "Fondée en 2015, GTIC SARL s'est imposée comme un acteur majeur du BTP et des services au Cameroun. Notre croissance constante témoigne de la confiance de nos clients et de notre engagement envers l'excellence.",
    about_vision_text: "Devenir le leader des services de construction, communication et distribution, reconnu pour notre innovation et notre qualité de service.",
    about_mission_text: "Fournir des services de classe mondiale en construction, communication et vente de matériels, en plaçant la satisfaction client et l'innovation au cœur de nos actions.",
    about_values_list: "Excellence • Intégrité • Innovation • Travail d'équipe • Satisfaction client",
    
    // Services
    services_title: "Nos Services",
    services_subtitle: "Des solutions complètes pour vos projets",
    services_learn_more: "En savoir plus",
    
    // Projects
    projects_title: "Nos Projets",
    projects_subtitle: "Découvrez nos réalisations",
    projects_all: "Tous",
    projects_completed: "Terminés",
    projects_ongoing: "En cours",
    projects_view: "Voir le projet",
    
    // Products
    products_title: "Nos Produits",
    products_subtitle: "Équipements et matériels de qualité",
    products_add_cart: "Ajouter au panier",
    products_view: "Voir détails",
    products_price: "Prix",
    products_in_stock: "En stock",
    products_out_of_stock: "Rupture de stock",
    
    // Training
    training_title: "Nos Formations",
    training_subtitle: "Développez vos compétences",
    training_duration: "Durée",
    training_price: "Prix",
    training_register: "S'inscrire",
    training_start: "Début",
    training_end: "Fin",
    training_spots: "Places disponibles",
    
    // Jobs
    jobs_title: "Offres d'emploi",
    jobs_subtitle: "Rejoignez notre équipe",
    jobs_apply: "Postuler",
    jobs_location: "Lieu",
    jobs_contract: "Contrat",
    jobs_deadline: "Date limite",
    jobs_requirements: "Prérequis",
    
    // Partners
    partners_title: "Nos Partenaires",
    partners_subtitle: "Ils nous font confiance",
    partners_become: "Devenir partenaire",
    
    // Contact
    contact_title: "Contactez-nous",
    contact_subtitle: "Nous sommes à votre écoute",
    contact_name: "Nom complet",
    contact_email: "Email",
    contact_phone: "Téléphone",
    contact_subject: "Sujet",
    contact_message: "Message",
    contact_send: "Envoyer",
    contact_address: "Adresse",
    contact_whatsapp: "WhatsApp",
    
    // Daily Life
    daily_life_title: "Notre Quotidien",
    daily_life_subtitle: "La vie chez GTIC SARL",
    daily_life_gallery: "Galerie Photos",
    
    // Cart
    cart_title: "Panier",
    cart_empty: "Votre panier est vide",
    cart_total: "Total",
    cart_checkout: "Demander un devis",
    cart_remove: "Retirer",
    cart_quantity: "Quantité",
    
    // Quote
    quote_title: "Demande de devis",
    quote_company: "Entreprise",
    quote_success: "Votre demande a été envoyée avec succès",
    
    // Common
    common_loading: "Chargement...",
    common_error: "Une erreur est survenue",
    common_success: "Succès",
    common_cancel: "Annuler",
    common_save: "Enregistrer",
    common_delete: "Supprimer",
    common_edit: "Modifier",
    common_search: "Rechercher",
    common_filter: "Filtrer",
    common_all: "Tous",
    common_fcfa: "FCFA",
    common_read_more: "Lire la suite",
    
    // Footer
    footer_description: "GTIC SARL, votre partenaire de confiance pour tous vos projets de construction, communication et fournitures au Cameroun.",
    footer_quick_links: "Liens rapides",
    footer_services: "Nos Services",
    footer_contact: "Contact",
    footer_follow: "Suivez-nous",
    footer_rights: "Tous droits réservés",
    footer_privacy: "Politique de confidentialité",
    footer_terms: "Conditions d'utilisation",
    
    // Admin
    admin_dashboard: "Tableau de bord",
    admin_services: "Services",
    admin_projects: "Projets",
    admin_products: "Produits",
    admin_trainings: "Formations",
    admin_jobs: "Emplois",
    admin_partners: "Partenaires",
    admin_daily_life: "Quotidien",
    admin_gallery: "Galerie",
    admin_contacts: "Messages",
    admin_applications: "Candidatures",
    admin_registrations: "Inscriptions",
    admin_partnership_requests: "Demandes partenariat",
    admin_quote_requests: "Demandes devis",
    admin_users: "Utilisateurs",
    admin_backup: "Sauvegarde",
    admin_notifications: "Notifications",
    admin_settings: "Paramètres",
    admin_new: "Nouveau",
    admin_pending: "En attente",
    admin_reviewed: "Examiné",
    admin_approved: "Approuvé",
    admin_rejected: "Rejeté"
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_about: "About",
    nav_services: "Services",
    nav_projects: "Projects",
    nav_daily_life: "Our Daily Life",
    nav_training: "Training",
    nav_careers: "Careers",
    nav_shop: "Shop",
    nav_partners: "Partners",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_login: "Login",
    nav_logout: "Logout",
    nav_get_quote: "Get a Quote",
    
    // Hero
    hero_title: "Building the future,",
    hero_title_2: "Connecting the world",
    hero_subtitle: "GTIC SARL, your trusted partner for construction, communication and printing services.",
    hero_cta: "Discover our services",
    hero_contact: "Contact us",
    
    // About
    about_title: "About GTIC SARL",
    about_history: "Our History",
    about_vision: "Our Vision",
    about_mission: "Our Mission",
    about_values: "Our Values",
    about_history_text: "Founded in 2015, GTIC SARL has established itself as a major player in construction and services in Cameroon. Our constant growth reflects the trust of our clients and our commitment to excellence.",
    about_vision_text: "To become the leader in construction, communication and distribution services, recognized for our innovation and quality of service.",
    about_mission_text: "To provide world-class services in construction, communication and equipment sales, placing customer satisfaction and innovation at the heart of our actions.",
    about_values_list: "Excellence • Integrity • Innovation • Teamwork • Customer satisfaction",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Complete solutions for your projects",
    services_learn_more: "Learn more",
    
    // Projects
    projects_title: "Our Projects",
    projects_subtitle: "Discover our achievements",
    projects_all: "All",
    projects_completed: "Completed",
    projects_ongoing: "Ongoing",
    projects_view: "View project",
    
    // Products
    products_title: "Our Products",
    products_subtitle: "Quality equipment and materials",
    products_add_cart: "Add to cart",
    products_view: "View details",
    products_price: "Price",
    products_in_stock: "In stock",
    products_out_of_stock: "Out of stock",
    
    // Training
    training_title: "Our Training Programs",
    training_subtitle: "Develop your skills",
    training_duration: "Duration",
    training_price: "Price",
    training_register: "Register",
    training_start: "Start",
    training_end: "End",
    training_spots: "Available spots",
    
    // Jobs
    jobs_title: "Job Openings",
    jobs_subtitle: "Join our team",
    jobs_apply: "Apply",
    jobs_location: "Location",
    jobs_contract: "Contract",
    jobs_deadline: "Deadline",
    jobs_requirements: "Requirements",
    
    // Partners
    partners_title: "Our Partners",
    partners_subtitle: "They trust us",
    partners_become: "Become a partner",
    
    // Contact
    contact_title: "Contact Us",
    contact_subtitle: "We are here to help",
    contact_name: "Full name",
    contact_email: "Email",
    contact_phone: "Phone",
    contact_subject: "Subject",
    contact_message: "Message",
    contact_send: "Send",
    contact_address: "Address",
    contact_whatsapp: "WhatsApp",
    
    // Daily Life
    daily_life_title: "Our Daily Life",
    daily_life_subtitle: "Life at GTIC SARL",
    daily_life_gallery: "Photo Gallery",
    
    // Cart
    cart_title: "Cart",
    cart_empty: "Your cart is empty",
    cart_total: "Total",
    cart_checkout: "Request a quote",
    cart_remove: "Remove",
    cart_quantity: "Quantity",
    
    // Quote
    quote_title: "Quote Request",
    quote_company: "Company",
    quote_success: "Your request has been sent successfully",
    
    // Common
    common_loading: "Loading...",
    common_error: "An error occurred",
    common_success: "Success",
    common_cancel: "Cancel",
    common_save: "Save",
    common_delete: "Delete",
    common_edit: "Edit",
    common_search: "Search",
    common_filter: "Filter",
    common_all: "All",
    common_fcfa: "FCFA",
    common_read_more: "Read more",
    
    // Footer
    footer_description: "GTIC SARL, your trusted partner for all your construction, communication and supply projects in Cameroon.",
    footer_quick_links: "Quick Links",
    footer_services: "Our Services",
    footer_contact: "Contact",
    footer_follow: "Follow Us",
    footer_rights: "All rights reserved",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Use",
    
    // Admin
    admin_dashboard: "Dashboard",
    admin_services: "Services",
    admin_projects: "Projects",
    admin_products: "Products",
    admin_trainings: "Training",
    admin_jobs: "Jobs",
    admin_partners: "Partners",
    admin_daily_life: "Daily Life",
    admin_gallery: "Gallery",
    admin_contacts: "Messages",
    admin_applications: "Applications",
    admin_registrations: "Registrations",
    admin_partnership_requests: "Partnership Requests",
    admin_quote_requests: "Quote Requests",
    admin_users: "Users",
    admin_backup: "Backup",
    admin_notifications: "Notifications",
    admin_settings: "Settings",
    admin_new: "New",
    admin_pending: "Pending",
    admin_reviewed: "Reviewed",
    admin_approved: "Approved",
    admin_rejected: "Rejected"
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('gtic_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('gtic_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getLocalizedContent = (content) => {
    if (!content) return '';
    if (typeof content === 'string') return content;
    return content[language] || content.fr || content.en || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getLocalizedContent }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
